import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'components/base';
import Icon, { ICON_TYPE } from 'components/icon';

import useUserContext from '../../context/user';
import UserAvatar from './avatar';
import useAvatarUpload from './useAvatarUpload';

/**
 * Avatar block for the /user page: current avatar (or initials fallback),
 * upload with a square crop step, and removal. Shows the cropped image
 * optimistically while the backend renders the served variants.
 */
const UserAvatarSettings = (props) => {
  const userContext = useUserContext();
  const avatar = useAvatarUpload(props.accessToken);

  const displayName = userContext.data.name || userContext.data.email;
  const hasAvatar = Boolean(avatar.previewUrl || userContext.data.avatar_url);

  return (
    <div className={props.className}>
      <div className="d-flex align-items-center" style={{ gap: 16 }}>
        <UserAvatar
          name={displayName}
          avatarUrl={avatar.previewUrl || userContext.data.avatar_url}
          avatarUrl2x={avatar.previewUrl ? null : userContext.data.avatar_url_2x}
          size={96}
        />
        <div className="d-flex align-items-center" style={{ gap: 8 }}>
          <Button
            type="outline"
            className="user-avatar-action"
            disabled={avatar.isSaving}
            onClick={avatar.openPicker}
          >
            <Icon
              type={ICON_TYPE.EDIT}
              size={20}
              title={hasAvatar ? 'Change photo' : 'Upload photo'}
            />
          </Button>
          {hasAvatar && !avatar.isSaving && (
            <Button type="outline" className="user-avatar-action" onClick={avatar.remove}>
              <Icon type={ICON_TYPE.TRASH} size={20} title="Remove photo" />
            </Button>
          )}
          {avatar.isSaving && <Spinner />}
        </div>
      </div>

      <input {...avatar.inputProps} />
    </div>
  );
};

UserAvatarSettings.propTypes = {
  accessToken: PropTypes.string,
  className: PropTypes.string,
};

export default UserAvatarSettings;
